// Money helpers for lead totals, payments and balances.
// Amounts are dollars with at most 2 decimals. Plain float maths leaves noise
// behind (1130.99 - 1050 = 80.99000000000001), which then shows up on screen and
// breaks exact-zero checks, so balances are worked out in whole cents.
// Keep in step with ci-crm-backend/Helpers/Money.js.

export const toCents = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? Math.round(number * 100) : 0;
};

export const roundMoney = (value) => toCents(value) / 100;

// Amount still owed, never negative. Exactly 0 when fully paid.
export const getBalance = (totalAmount, paidAmount) =>
    Math.max(0, toCents(totalAmount) - toCents(paidAmount)) / 100;

// Completed payments count toward the paid total; payments saved before the
// status field existed have none and count too.
export const computePaidAmount = (payments = []) =>
    (payments || []).reduce((sum, payment) => (
        payment?.status === 'Completed' || payment?.status === undefined
            ? sum + toCents(payment.amount)
            : sum
    ), 0) / 100;

// "$1,130.99"
export const formatMoney = (value) =>
    `$${roundMoney(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
